import { GoogleOAuthProvider } from '@react-oauth/google';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { LoadingProvider } from './context/LoadingContext';
import { SettingsProvider } from './context/SettingsContext';
import './index.css';
import './n18i';
import { store } from './redux/store';
import { MaintenanceProvider } from './context/MaintenanceContext';

const queryClient = new QueryClient({
   defaultOptions: {
      queries: {
         refetchOnWindowFocus: false,
         retry: 0,
         staleTime: 0,
         cacheTime: 5 * 60 * 1000,
      },
   },
});
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
   // <React.StrictMode>
   <BrowserRouter basename={process.env.PUBLIC_URL}>
      {/* <LoadingProvider> */}
      <Provider store={store}>
         <GoogleOAuthProvider
            clientId='262632697116-8snms6med1f4mrh54fevbpe2m3b0oloe.apps.googleusercontent.com'
         // clientId='157391346566-suetju1olgdn4k5jf2adpfv1g4nk8s1l.apps.googleusercontent.com'
         // clientId="472047522777-fitlob7vhijc0bavk9vm18aek39fjitq.apps.googleusercontent.com"
         >
            <SettingsProvider>
               <QueryClientProvider client={queryClient}>
                  <MaintenanceProvider><App /></MaintenanceProvider>

               </QueryClientProvider>
            </SettingsProvider>
         </GoogleOAuthProvider>
      </Provider>
      {/* </LoadingProvider> */}
   </BrowserRouter>
   // </React.StrictMode>
);
